var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-label", {
    attrs: { label: _vm.label, "class-name": _vm.formLabelClassName },
    scopedSlots: _vm._u(
      [
        {
          key: "body",
          fn: function () {
            return [
              _vm._l(_vm.items, function (item, i) {
                return _c("div", { key: i }, [
                  _c("label", { staticClass: "pega-input display-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: item.isChecked,
                          expression: "item.isChecked",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(item.isChecked)
                          ? _vm._i(item.isChecked, null) > -1
                          : item.isChecked,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = item.isChecked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(item, "isChecked", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  item,
                                  "isChecked",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(item, "isChecked", $$c)
                          }
                        },
                      },
                    }),
                    _c("span", { staticClass: "pega-break" }, [
                      _vm._v(_vm._s(item.label)),
                    ]),
                  ]),
                  _vm._v(" "),
                  item.isShowTrash
                    ? _c("button", {
                        staticClass: "boss-icon-trash",
                        attrs: { disabled: item.isChecked },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("delete", item.id)
                          },
                        },
                      })
                    : _vm._e(),
                ])
              }),
              _vm._v(" "),
              _vm._t("footer"),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }